import type { Player } from '@dicetechnology/doris-core';

import { DiceReceiverManager } from '../services';

import { throwError } from './throwError';

export const configureDatazoomPlugin = async (player: Player, withV5: boolean): Promise<void> => {
    const DATAZOOM_PLUGIN_NAME = 'datazoom';

    const diceReceiverManager = DiceReceiverManager.getInstance();
    const { datazoomConfigId, enablePauseAds, treatAllOverlayAdsAsPauseAds, enablePauseAdsLoopMode } =
        diceReceiverManager.getSettings() ?? throwError('Invalid state!');

    const shouldUseDatazoomPlugin = datazoomConfigId && withV5;
    if (!shouldUseDatazoomPlugin) {
        return;
    }

    const { DatazoomPlugin } = await import('@dicetechnology/doris-plugin-datazoom');

    const existingPlugin = player.getPluginByType(DatazoomPlugin);
    if (!existingPlugin) {
        player.addPlugin({
            name: DATAZOOM_PLUGIN_NAME,
            Plugin: DatazoomPlugin,
            config: {
                configurationId: datazoomConfigId,
                enablePauseAds,
                treatAllOverlayAdsAsPauseAds,
                enablePauseAdsLoopMode
            }
        });
    } else {
        existingPlugin.setConfigurationId(datazoomConfigId);
    }
};
